export function isPresentString(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

export interface UserProfileFields {
  User_FirstName?: string | null;
  User_LastName?: string | null;
  User_Email?: string | null;
  User_DOB?: string | null;
  User_PhoneNumber?: string | null;
}

export function isUserProfileComplete(user: UserProfileFields): boolean {
  return (
    isPresentString(user.User_FirstName) &&
    isPresentString(user.User_LastName) &&
    isPresentString(user.User_Email) &&
    isPresentString(user.User_DOB) &&
    isPresentString(user.User_PhoneNumber)
  );
}

export function getUserProfileMissingFields(user: UserProfileFields): string[] {
  const missing: string[] = [];
  if (!isPresentString(user.User_FirstName)) missing.push('first name');
  if (!isPresentString(user.User_LastName)) missing.push('last name');
  if (!isPresentString(user.User_Email)) missing.push('email');
  if (!isPresentString(user.User_DOB)) missing.push('date of birth');
  if (!isPresentString(user.User_PhoneNumber)) missing.push('phone number');
  return missing;
}

export function isCourtSelected(courtGuid: string | null | undefined): boolean {
  return isPresentString(courtGuid);
}
